import { render, staticRenderFns } from "./UpgradePage.vue?vue&type=template&id=8499ab88&"
import script from "./UpgradePage.vue?vue&type=script&lang=js&"
export * from "./UpgradePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8499ab88')) {
      api.createRecord('8499ab88', component.options)
    } else {
      api.reload('8499ab88', component.options)
    }
    module.hot.accept("./UpgradePage.vue?vue&type=template&id=8499ab88&", function () {
      api.rerender('8499ab88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/helpcenter/components/UpgradePage.vue"
export default component.exports